import success from './assessment_Success.json'
import fail from './assessment_Fail.json'
import leadFirst from './leadBoardFirst.json'

export const AnimationData = { success,fail,leadFirst }